import styled from 'styled-components';
import { breakpoint, breakpointNames, fontSize } from '../Mixins';

const Select = styled.select`
  position: relative;
  cursor: pointer;
  line-height: inherit;
  max-width: 343px;
  height: 50px;
  padding: 10px;
  border-width: 1px;
  border-style: solid;
  color: ${({ theme }) => theme.input.color.text};
  font-weight: ${({ theme }) => theme.input.fontWeight};
  border-radius: ${({ theme }) => theme.input.borderRadius};
	border-color: ${({ theme }) => theme.input.color.border};
  background-color: ${({ theme }) => theme.body.color.shading};
  background: ${({ theme }) => theme.input.color.background};

  &:focus {
    outline-color: ${({ theme }) => theme.input.color.outline};
  }

  ${breakpoint(breakpointNames.tablet, `
    width: 343px;
  `)};

  ${fontSize}
`;

export default Select;
